import { DialogIds } from '@/services/Dialog/DialogIds.enum';
import React from 'react';
import { Action } from 'redux';

export type LegacyDialogParams = {
    title?: string;
    body?: JSX.Element | JSX.Element[] | string;
    customButtons?: JSX.Element | JSX.Element[] | string;
    onClickCancel?(): void;
    onClickConfirm?(): void;
    onClickDelete?(): void;
    cancelLabel?: string;
    confirmLabel?: string;
    deleteLabel?: string;
    fullScreen?: boolean;
    id?: string;
    onClickDestructive?(): void;
    isHiddenManually?: boolean;
    isDisabled?: boolean;
    width?: string | number;
    height?: string | number;
    destructiveLabel?: string;
    disableHeader?: boolean;
    disableFooter?: boolean;
    ref?: React.Ref<HTMLInputElement>;
    isLoading?: boolean;
    disabledContentPadding?: boolean;
    header?: JSX.Element;
    onClose?: () => void;
};

export type ShowDialogParams =
    | LegacyDialogParams
    | {
          id: DialogIds;
      };

type DialogsInternalConfig = {
    isOpened: boolean;
};

export interface ShowDialogAction extends Action {
    type: '@@dialog/SHOW';
    payload: ShowDialogParams & DialogsInternalConfig;
}

export interface UpdateDialogAction extends Action {
    type: '@@dialog/UPDATE';
    payload: ShowDialogParams & DialogsInternalConfig;
}

export interface HideDialogAction extends Action {
    type: '@@dialog/HIDE';
    payload: {
        isOpened: boolean;
    };
}

export type DialogState = ShowDialogParams & DialogsInternalConfig;

export interface DisableDialogAction extends Action {
    type: '@@dialog/DISABLE';
    payload: {
        isDisabled: boolean;
    };
}

export const isIdBasedDialog = (props: { id: DialogIds } | LegacyDialogParams): props is { id: DialogIds } =>
    Object.values(DialogIds).includes((props as { id: DialogIds }).id);
